import { render, staticRenderFns } from "./ConfirmAddPurchase.vue?vue&type=template&id=4aaaaefc&scoped=true&"
import script from "./ConfirmAddPurchase.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaaaefc",
  null
  
)

export default component.exports